module.exports = __webpack_public_path__ + "fonts/Gotham-Medium.27a90e87.otf";